import React from "react";
import Reveal from "./Reveal";
import Counter from "./Counter";
import { STATS } from "../data/data";

export function Stats() {
  return (
    <section className="py-20 px-6 md:px-10" style={{ background: "#10141B" }}>
      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-10 text-center">
        {STATS.map((s, i) => (
          <Reveal key={s.label} delay={i * 0.1}>
            <div>
              <p style={{ fontFamily: "Fraunces, serif", color: "#1E9AFF" }} className="text-4xl md:text-5xl mb-2">
                <Counter to={s.to} suffix={s.suffix} />
              </p>
              <p className="text-xs uppercase tracking-widest text-white opacity-60" style={{ fontFamily: "'JetBrains Mono', monospace" }}>
                {s.label}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}

export default Stats;
